(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["location-stock-buckets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('location-stock-buckets')) {
    customElements.define(
      'location-stock-buckets',
      class extends HTMLElement {
        connectedCallback() {
          this.load();
        }

        async load() {
          const variantId = this.dataset.variantId;
          if (!variantId) return;

          try {
            const response = await fetch(`/apps/location-stock?variant_id=${encodeURIComponent(variantId)}`, {
              headers: { Accept: 'application/json' }
            });
            if (!response.ok) return;

            const data = await response.json();
            const buckets = Array.isArray(data.buckets) ? data.buckets : [];
            if (buckets.length === 0) return;

            const list = this.querySelector('.location-stock-buckets__list');
            list.replaceChildren(
              ...buckets.map((bucket) => {
                const item = document.createElement('li');
                item.className = 'location-stock-buckets__item';

                const labels = {
                  store: 'In Store Stock Availability',
                  online: 'Online Stock Availability',
                  bargain: 'Bargain Bin/Open Box Stock Availability'
                };

                const status = document.createElement('span');
                status.className = `location-stock-buckets__status location-stock-buckets__status--${bucket.tone}`;
                const state = bucket.state === 'low_stock' ? 'Low Stock' : 'In Stock';
                status.textContent = `${labels[bucket.key] || bucket.label} — ${state}`;

                item.append(status);
                return item;
              })
            );
            this.hidden = false;
          } catch {
            this.hidden = true;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
